module.exports = __webpack_public_path__ + "static/me-2db062f408f3cc61195d88e241e2ff3d.png";